import { createFileRoute } from "@tanstack/react-router";
import { Valuations } from "@/components/Valuations";

export const Route = createFileRoute("/_authenticated/valuations/")({
  component: Valuations,
  staticData: { page: "valuations" },
});
